var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencilruler = function SvgPencilruler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m51.151 45.908 4.194-4.198M62.814 9.07l12.59 12.586M41.71 55.345l9.441-9.437M57.57 14.314l5.244-5.243M42.76 29.124l14.81-14.81M29.125 42.76l9.44-9.438M75.403 21.656 55.345 41.71M22.272 74.788 41.71 55.345M9.686 62.202l12.586 12.586M9.686 62.202 29.125 42.76M9.686 62.202 4.44 80.032l17.833-5.244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m62.814 9.07 5.243-5.243S73.3.68 78.544 5.926c5.243 5.243 2.099 10.487 2.099 10.487l-5.244 5.243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M57.57 14.314 70.156 26.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.57,
    cy: 14.314,
    r: 1.483,
    fill: "#F28230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M35.417 49.053 21.222 63.25M62.814 21.656 49.053 35.417M48.003 36.467l1.05-1.05M48.003 36.467 35.417 49.053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M42.76 29.125 16.105 2.47 2.47 16.105 29.125 42.76M41.71 55.346 68.37 82 82 68.37 58.609 44.974"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m73.178 61.638-6.293 6.293"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m66.885 55.345-3.148 3.149"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m60.589 49.053-6.293 6.293M41.71 42.76l6.293-6.293M29.125 30.174l6.292-6.293"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m25.98 20.733 3.145-3.145"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAB331",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m16.539 17.589 6.293-6.293"
  })));
};
export default SvgPencilruler;